<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text class="black--text">
        <v-container class="pa-5">
          <v-row>
            <v-col class="py-0 my-1" cols="12" md="4">
              <v-list-item class="px-0">
                <v-list-item-avatar color="secondary">
                  <v-icon dark>mdi-account-multiple</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <div><span class="caption grey--text">Jenjang</span></div>
                  <span class="info--text mb-0" style="font-size: 17px">
                    {{ $getDeepObj(initValue, 'm_jenjang.singkat') }} ({{
                      $getDeepObj(initValue, 'm_jenjang.keterangan')
                    }})
                  </span>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="4">
              <div><span class="caption grey--text">Nama Daerah</span></div>
              <span class="mb-0">
                {{ $getDeepObj(initValue, 'instansi.nama') }}
              </span>
            </v-col>
            <v-col cols="12" md="4">
              <div><span class="caption grey--text">Nama Penilai</span></div>
              <span class="mb-0">
                {{ $getDeepObj(akun, 'nama') }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert type="info" text dense color="info" class="mb-0 mt-4">
                Pada jenjang
                <strong>
                  {{ $getDeepObj(initValue, 'm_jenjang.singkat') }} ({{
                    $getDeepObj(initValue, 'm_jenjang.keterangan')
                  }})
                </strong>
                total kandidat adalah
                <strong>{{ $getDeepObj(initValue, 'jml_kasek') || 0 }}</strong>
                <br />
                dengan jumlah Kepala Sekolah Negeri adalah
                <strong>{{ $getDeepObj(initValue, 'jml_kasek_negeri') || 0 }}</strong> dan jumlah Kepala Sekolah Swasta
                adalah <strong>{{ $getDeepObj(initValue, 'jml_kasek_swasta') || 0 }}</strong>
              </v-alert>
            </v-col>
            <v-col cols="12" class="subtitle-1">
              Dari jumlah sekolah yang nantinya akan menjadi Pelaksana Program Sekolah Penggerak, berapa persentase di
              antaranya yang diharapkan merupakan Sekolah Negeri
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <div>
                <div>
                  <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                    Isikan Persentase Kepala Sekolah Negeri
                  </span>
                </div>
                <template>
                  <v-text-field
                    v-if="mode === 'form'"
                    v-model="form.persen_negeri"
                    outlined
                    dense
                    hide-details
                    v-mask="'###'"
                    append-icon="%"
                  />
                  <div v-else class="grey lighten-3 py-1">
                    <span class="black--text subtitle-1 ma-2 my-4">{{ form.persen_negeri || 0 }}%</span>
                  </div>
                </template>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div>
                <div>
                  <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                    Persentase Kepala Sekolah Swasta (terisi secara otomatis)
                  </span>
                </div>
                <template>
                  <div class="grey lighten-3 py-1">
                    <span class="black--text subtitle-1 ma-2 my-4" v-if="form.persen_negeri === null"></span>
                    <span class="black--text subtitle-1 ma-2 my-4" v-else>{{ form.persen_swasta || 0 }}%</span>
                  </div>
                </template>
              </div>
            </v-col>
            <v-col cols="12" v-if="form.persen_negeri">
              <v-alert
                border="left"
                colored-border
                :color="Number(form.persen_negeri) + Number(form.persen_swasta) === 100 ? 'success' : 'error'"
                :class="[
                  Number(form.persen_negeri) + Number(form.persen_swasta) === 100 ? 'bg-success' : 'bg-error',
                  'mb-0',
                ]"
                dense
              >
                <span v-if="Number(form.persen_negeri) + Number(form.persen_swasta) === 100">
                  Persentase Ajuan Kepala Sekolah yang ingin diterima sudah sesuai
                  <strong>(Negeri {{ form.persen_negeri }}%</strong> dan
                  <strong>Swasta {{ form.persen_swasta }}%)</strong>
                </span>
                <span v-else>
                  Persentase Ajuan Kepala Sekolah yang ingin diterima belum sesuai
                  <strong>total persentase tidak boleh melebihi 100%</strong>
                </span>
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    initValue: {
      default: () => null,
    },
    mode: {
      default: 'form',
    },
  },

  computed: {
    ...mapState('preferensi', {
      akun: (state) => Object.assign({}, state.data && state.data.akun),
    }),
  },

  data() {
    return {
      form: {},
    };
  },

  methods: {
    reset() {
      this.$set(this, 'form', {});
    },

    initForm(value) {
      this.$set(this.form, 'persen_negeri', value.persen_negeri === null ? null : value.persen_negeri);
      this.$set(this.form, 'persen_swasta', value.persen_swasta === null ? null : value.persen_swasta);
    },

    getPersenKuota() {
      return this.form;
    },

    getErrors() {
      let msg = '';
      const mapMsg = {
        persen_negeri: 'Persentase KS yang ingin diterima di Sekolah Negeri',
        persen_swasta: 'Persentase KS yang ingin diterima di Sekolah Swasta',
      };

      if (Number(this.form.persen_negeri) + Number(this.form.persen_swasta) !== 100) {
        msg =
          'Persentase Negeri dan Swasta totalnya harus 100% dengan memperhatikan ketersediaan dan kesesuaian jumlah pada masing masing Sekolah Negeri dan Sekolah Swasta';
      }

      for (const key of Object.keys(mapMsg)) {
        if (this.form[key] === null) {
          msg = mapMsg[key] || '';
        }
      }

      return msg;
    },

    onChangePersen() {
      this.form.persen_swasta = 100 - (this.form.persen_negeri || 0);

      if (this.form.persen_swasta < 0) {
        this.form.persen_swasta = 0;
      }
    },
  },

  watch: {
    initValue: 'initForm',
    'form.persen_negeri': 'onChangePersen',
  },
};
</script>
